import { useEffect, useState } from "react";
import { navLinks, siteInfo } from "@/mocks/home";

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      className={`fixed inset-x-0 top-0 z-50 transition-colors duration-300 ${
        scrolled ? "bg-background-50/95 backdrop-blur border-b border-background-200/70" : "bg-transparent"
      }`}
    >
      <div className="mx-auto flex h-16 w-full items-center justify-between px-4 md:px-6">
        <a href="#top" className="flex items-center gap-2 cursor-pointer">
          <span
            className={`flex h-9 w-9 items-center justify-center rounded-md ${
              scrolled ? "bg-primary-500 text-background-50" : "bg-background-50/15 text-background-50"
            }`}
          >
            <i className="ri-file-text-line text-lg"></i>
          </span>
          <span className="flex flex-col leading-tight">
            <span
              className={`font-heading text-base font-bold tracking-wide ${
                scrolled ? "text-foreground-950" : "text-background-50"
              }`}
            >
              {siteInfo.name}
            </span>
            <span
              className={`hidden text-[11px] sm:block ${
                scrolled ? "text-foreground-500" : "text-background-100/80"
              }`}
            >
              {siteInfo.slogan}
            </span>
          </span>
        </a>

        <nav className="hidden items-center gap-1 md:flex">
          {navLinks.map((link) => (
            <a
              key={link.id}
              href={`#${link.id}`}
              className={`rounded-md px-3 py-2 text-sm font-medium transition-colors cursor-pointer ${
                scrolled
                  ? "text-foreground-700 hover:bg-primary-100 hover:text-primary-700"
                  : "text-background-100 hover:bg-background-50/15 hover:text-background-50"
              }`}
            >
              {link.label}
            </a>
          ))}
        </nav>

        <button
          type="button"
          aria-label={menuOpen ? "关闭菜单" : "打开菜单"}
          onClick={() => setMenuOpen((v) => !v)}
          className={`flex h-10 w-10 items-center justify-center rounded-md md:hidden cursor-pointer ${
            scrolled ? "text-foreground-800 bg-background-100" : "text-background-50 bg-background-50/15"
          }`}
        >
          <i className={menuOpen ? "ri-close-line text-xl" : "ri-menu-line text-xl"}></i>
        </button>
      </div>

      {menuOpen && (
        <div className="border-t border-background-200/70 bg-background-50 md:hidden">
          <nav className="flex flex-col px-4 py-3">
            {navLinks.map((link) => (
              <a
                key={link.id}
                href={`#${link.id}`}
                onClick={() => setMenuOpen(false)}
                className="rounded-md px-3 py-3 text-sm font-medium text-foreground-700 transition-colors hover:bg-primary-100 hover:text-primary-700 cursor-pointer"
              >
                {link.label}
              </a>
            ))}
          </nav>
        </div>
      )}
    </header>
  );
}